export default __webpack_public_path__ + "static/media/classicHome.246e5cd7.jpg";